import { Select } from "@/components/select";
import { __ } from "@wordpress/i18n";

export const lengthOptions = [
    {
        value: "short",
        label: __("Short (400-800 words)", "antimanual"),
        min: 400,
        max: 800,
    },
    {
        value: "medium",
        label: __("Medium (800-1200 words)", "antimanual"),
        min: 800,
        max: 1200,
    },
    {
        value: "long",
        label: __("Long (1200-2000 words)", "antimanual"),
        min: 1200,
        max: 2000,
    },
];

type Props = React.HTMLProps<HTMLDivElement> & {
    length: (typeof lengthOptions)[0];
    setLength(length: (typeof lengthOptions)[0]): void;
};

export function ArticleLength({ length, setLength }: Props) {
    const getLength = (length: string) => {
        const lengthOption = lengthOptions.find((option) => option.value === length);
        return lengthOption || lengthOptions[1];
    };

    return (
        <Select
            value={length.value}
            onChange={(value) => setLength(getLength(value))}
            label={__("Article Length", "antimanual")}
            help={__("Select the desired length for the content of the generated posts.", "antimanual")}
            options={lengthOptions}
        />
    );
}
